
<v-snackbar
  class="snackbar"
  v-model="snackbar.visible"
  :timeout="snackbar.timeout"
  :multi-line="snackbar.multiline === true">
      
    {{ snackbar.text }}
      
    <v-btn text @click="closeSnackbar">Close</v-btn>
  
</v-snackbar>
